import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import { useDropzone } from 'react-dropzone';
import { FileImportHistoryGrid, FILE_IMPORT_HISTORY_GRID_NAMES } from './FileImportHistoryGrid';

// SERVICES
import { submitFile } from '../../services';

const styles = theme => ({
  container: {
    flex: 1,
    backgroundColor: 'white',
    padding: 20,

    '& > *': {
      alignSelf: 'stretch',
    },
  },

  dropzone: {
    backgroundColor: '#F8F8F8',
    borderStyle: 'dashed',
    borderWidth: 2,
    borderColor: 'rgba(0,0,0,0.1)',
    color: 'rgba(0,0,0,0.4)',
    padding: 20,
    textAlign: 'center',
  },
});

export const FileImport = withStyles(styles)(props => {
  const { classes } = props;
  const [files, setFiles] = useState([]);
  const [requestDetails, setRequestDetails] = useState({});
  const [disableSubmit, setDisableSubmit] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    accept: '.csv, .xls, .xlsx',
    onDrop: acceptedFiles => {
      setFiles(
        acceptedFiles.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          }),
        ),
      );
    },
  });

  const submitFilesAsync = () => {
    const rd = Object.assign({}, requestDetails);
    // submit each file one by one (the endpoint expects one file)
    files.forEach(async f => {
      setDisableSubmit(true);
      try {
        rd[f.name] = {
          filename: f.name,
          statusCode: '-',
          message: 'Submitting',
        };
        setRequestDetails(rd);
        const res = await submitFile(f);
        rd[f.name].statusCode = res.status;
        rd[f.name].message = 'Success';
        setRequestDetails(rd);

        if (Object.keys(requestDetails).every(filename => requestDetails[filename].statusCode === 200)) {
          setDisableSubmit(false);
        }
      } catch (err) {
        console.log(err);
        rd[f.name].statusCode = err.status;
        rd[f.name].message = await err.text();
        setRequestDetails(rd);
      } finally {
        setFiles([]);
      }
    });
  };

  const thumbs = files.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  return (
    <main className={classnames('col-center-center', classes.container)}>
      <div {...getRootProps({ className: classes.dropzone })}>
        <input {...getInputProps()} />
        <p>Drag 'n' drop some files here, or click to select files</p>
      </div>
      {!!files.length && (
        <aside>
          <h4>Files</h4>
          <ul>{thumbs}</ul>
        </aside>
      )}
      <aside>
        <h3>Progress</h3>
        {Object.keys(requestDetails).map(filename => {
          return (
            <div key={`progress_${filename}`} style={{ marginBottom: 15 }}>
              <div>File: {filename}</div>
              <div>Status: {requestDetails[filename].statusCode}</div>
              <div>Message: {requestDetails[filename].message}</div>
            </div>
          );
        })}
      </aside>
      <div>
        <button disabled={disableSubmit} onClick={submitFilesAsync}>
          Submit file(s)
        </button>
      </div>

      <br />
      {/* <hr style={{ width: '100%' }} /> */}
      <div className={classnames('flex-1', 'col-center-center')}>
        <h2>Import History</h2>
        <FileImportHistoryGrid gridName={FILE_IMPORT_HISTORY_GRID_NAMES.IMPORT_PAGE} />
      </div>
    </main>
  );
});

FileImport.propTypes = {};

FileImport.defaultProps = {};
